// Mock data for Forsyt MVP Dashboard

export const riskMetrics = {
  upsideAtRisk: {
    value: 680000,
    label: 'Upside at risk',
    subtitle: 'Resolved This Week',
    color: 'blue'
  },
  commitAtRisk: {
    value: 1240000,
    label: 'Commit at risk',
    subtitle: 'Resolved This Week',
    color: 'teal'
  },
  dealsAtRisk: {
    value: 320000,
    label: 'Deals at risk',
    subtitle: 'High-priority',
    color: 'yellow'
  }
};

export const dealsPipeline = [
  {
    id: 1,
    companyName: 'Acme Corp',
    contactName: 'Sarah Chen',
    avatar: 'AC',
    avatarColor: 'bg-blue-600',
    dueIn: '14d stuck',
    status: 'Ghosting',
    statusColor: 'bg-green-100 text-green-700',
    poc: 'CTO Ghosting',
    dealValue: 120000,
    actions: 4,
    riskCategory: 'upside',
    opportunityId: 1
  },
  {
    id: 2,
    companyName: 'Global Tech',
    contactName: 'Mike Ross',
    avatar: 'GT',
    avatarColor: 'bg-orange-600',
    dueIn: '8d stuck',
    status: 'Evaluation',
    statusColor: 'bg-yellow-100 text-yellow-700',
    poc: 'Competitor',
    dealValue: 85000,
    actions: 3,
    riskCategory: 'commit',
    opportunityId: 2
  },
  {
    id: 3,
    companyName: 'Starlight SaaS',
    contactName: 'Elena Wu',
    avatar: 'SS',
    avatarColor: 'bg-gray-900',
    dueIn: '21d stuck',
    status: 'Proposal',
    statusColor: 'bg-green-100 text-green-700',
    poc: 'Budget Freeze',
    dealValue: 62000,
    actions: 5,
    riskCategory: 'deals',
    opportunityId: 3
  },
  {
    id: 4,
    companyName: 'Orbit Inc',
    contactName: 'James Bond',
    avatar: 'OI',
    avatarColor: 'bg-red-600',
    dueIn: '5d stuck',
    status: 'Proposal',
    statusColor: 'bg-green-100 text-green-700',
    poc: 'Champion Silent',
    dealValue: 53000,
    actions: 2,
    riskCategory: 'deals',
    opportunityId: 4
  }
];

export const opportunities = [
  {
    id: 1,
    accountName: 'Innovate Labs',
    industry: 'Technology',
    contactName: 'Sarah Thompson',
    avatar: 'IL',
    avatarColor: 'bg-blue-600',
    stage: 'Negotiation',
    stageColor: 'bg-green-100 text-green-700',
    riskSignal: null,
    dealValue: 156000,
    quarter: 'Q2 2026'
  },
  {
    id: 2,
    accountName: 'TechScale Inc',
    industry: 'SaaS',
    contactName: 'Michael Chen',
    avatar: 'TS',
    avatarColor: 'bg-teal-600',
    stage: 'Proposal',
    stageColor: 'bg-yellow-100 text-yellow-700',
    riskSignal: 'No activity',
    riskColor: 'text-red-600',
    dealValue: 125000,
    quarter: 'Q2 2026'
  },
  {
    id: 3,
    accountName: 'CloudNine Systems',
    industry: 'Cloud Services',
    contactName: 'Emily Rodriguez',
    avatar: 'CS',
    avatarColor: 'bg-purple-600',
    stage: 'Discovery',
    stageColor: 'bg-blue-100 text-blue-700',
    riskSignal: null,
    dealValue: 67000,
    quarter: 'Q2 2026'
  },
  {
    id: 4,
    accountName: 'DataDriven Co',
    industry: 'Analytics',
    contactName: 'James Wilson',
    avatar: 'DD',
    avatarColor: 'bg-orange-600',
    stage: 'Negotiation',
    stageColor: 'bg-green-100 text-green-700',
    riskSignal: 'Champion silent',
    riskColor: 'text-red-600',
    dealValue: 45000,
    quarter: 'Q1 2026'
  },
  {
    id: 5,
    accountName: 'RetailHub Corp',
    industry: 'Retail',
    contactName: 'Lisa Martinez',
    avatar: 'RH',
    avatarColor: 'bg-pink-600',
    stage: 'Renewal',
    stageColor: 'bg-purple-100 text-purple-700',
    riskSignal: null,
    dealValue: 320000,
    quarter: 'Q2 2026'
  },
  {
    id: 6,
    accountName: 'Acme Corp',
    industry: 'Enterprise',
    contactName: 'Sarah Chen',
    avatar: 'AC',
    avatarColor: 'bg-blue-600',
    stage: 'Contract',
    stageColor: 'bg-green-100 text-green-700',
    riskSignal: null,
    dealValue: 125000,
    quarter: 'Q1 2026'
  },
  {
    id: 7,
    accountName: 'NexGen AI',
    industry: 'AI/ML',
    contactName: 'David Kim',
    avatar: 'NA',
    avatarColor: 'bg-indigo-600',
    stage: 'Proposal',
    stageColor: 'bg-yellow-100 text-yellow-700',
    riskSignal: 'Budget hold',
    riskColor: 'text-red-600',
    dealValue: 200000,
    quarter: 'Q1 2026'
  },
  {
    id: 8,
    accountName: 'FinFlow Systems',
    industry: 'Finance',
    contactName: 'Rachel Park',
    avatar: 'FS',
    avatarColor: 'bg-cyan-600',
    stage: 'Discovery',
    stageColor: 'bg-blue-100 text-blue-700',
    riskSignal: null,
    dealValue: 162000,
    quarter: 'Q2 2026'
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    avatar: 'SM',
    avatarColor: 'bg-indigo-900',
    region: 'West',
    role: 'Rep',
    roleColor: 'bg-green-100 text-green-700',
    pipeline: 281000,
    dealsCount: 4,
    actionRate: 78,
    actionTrend: 'down',
    atRisk: 1
  },
  {
    id: 2,
    name: 'David Park',
    avatar: 'DP',
    avatarColor: 'bg-blue-600',
    region: 'West',
    role: 'Rep',
    roleColor: 'bg-green-100 text-green-700',
    pipeline: 256000,
    dealsCount: 3,
    actionRate: 85,
    actionTrend: 'up',
    atRisk: null
  },
  {
    id: 3,
    name: 'Emily Watson',
    avatar: 'EW',
    avatarColor: 'bg-orange-600',
    region: 'West',
    role: 'Rep',
    roleColor: 'bg-green-100 text-green-700',
    pipeline: 411000,
    dealsCount: 3,
    actionRate: 45,
    actionTrend: 'down',
    atRisk: 2
  },
  {
    id: 4,
    name: 'James Wilson',
    avatar: 'JW',
    avatarColor: 'bg-pink-600',
    region: 'East',
    role: 'Rep',
    roleColor: 'bg-green-100 text-green-700',
    pipeline: 365000,
    dealsCount: 3,
    actionRate: 62,
    actionTrend: 'down',
    atRisk: 1
  },
  {
    id: 5,
    name: 'Emily Chen',
    avatar: 'EC',
    avatarColor: 'bg-teal-600',
    region: 'East',
    role: 'CSM',
    roleColor: 'bg-blue-100 text-blue-700',
    pipeline: 28000,
    dealsCount: 2,
    actionRate: 92,
    actionTrend: 'up',
    atRisk: null
  },
  {
    id: 6,
    name: 'Michael Torres',
    avatar: 'MT',
    avatarColor: 'bg-purple-600',
    region: 'West',
    role: 'Manager',
    roleColor: 'bg-purple-100 text-purple-700',
    pipeline: null,
    reportsCount: 3,
    actionRate: 88,
    actionTrend: 'up',
    atRisk: null
  }
];

// Rep - Today's Focus data
export const todaysFocusMetrics = [
  { label: 'High Impact', value: 1, color: 'orange' },
  { label: 'Follow-ups Due', value: 2, color: 'green' },
  { label: 'Opportunities', value: 2, color: 'teal' },
  { label: 'CRM Tasks', value: 5, color: 'gray' },
  { label: 'Calls & Meetings', value: 2, color: 'pink' },
];

export const todaysActions = [
  {
    id: 1,
    category: 'START HERE',
    badge: 'HIGHEST IMPACT',
    badgeColor: 'bg-red-50 text-red-600 border-red-200',
    borderColor: 'border-l-red-500',
    bgColor: 'bg-red-50/40',
    title: 'Send contract',
    account: 'Innovate Labs',
    dealValue: 156000,
    dealTag: 'Deal',
    description: 'All stakeholders aligned. Legal approved.',
    urgency: null,
  },
  {
    id: 2,
    category: 'NEEDS FOLLOW-UP',
    badge: null,
    borderColor: 'border-l-transparent',
    bgColor: 'bg-orange-50/40',
    title: 'Follow up on proposal',
    account: 'TechScale Inc',
    dealValue: 125000,
    dealTag: 'Deal',
    description: 'Reference GrowthForce, similar deals recently closed.',
    urgency: 'Next touch overdue (5 days)',
  },
  {
    id: 3,
    category: 'NEEDS FOLLOW-UP',
    badge: null,
    borderColor: 'border-l-transparent',
    bgColor: 'bg-orange-50/40',
    title: 'Re-engage champion',
    account: 'DataDriven Co',
    dealValue: 45000,
    dealTag: 'Deal',
    description: 'Champion has gone silent. Try reaching VP of Sales directly.',
    urgency: 'No response (8 days)',
  },
  {
    id: 4,
    category: 'UPCOMING',
    badge: null,
    borderColor: 'border-l-transparent',
    bgColor: 'bg-gray-50',
    title: 'Prepare demo deck',
    account: 'CloudNine Systems',
    dealValue: 67000,
    dealTag: 'Deal',
    description: 'Technical deep-dive scheduled for Thursday. Prepare integrations slides.',
    urgency: null,
  },
  {
    id: 5,
    category: 'UPCOMING',
    badge: null,
    borderColor: 'border-l-transparent',
    bgColor: 'bg-gray-50',
    title: 'Schedule QBR review',
    account: 'RetailHub Corp',
    dealValue: 320000,
    dealTag: 'Renewal',
    description: 'Renewal coming up in 45 days. Schedule quarterly business review.',
    urgency: null,
  },
];

export const crmHygieneActions = [
  { id: 1, title: 'Update close date for Innovate Labs', type: 'Field Update', dueDate: 'Overdue by 3 days' },
  { id: 2, title: 'Add next steps for TechScale Inc deal', type: 'Missing Data', dueDate: 'Due today' },
  { id: 3, title: 'Log call notes from DataDriven meeting', type: 'Activity Log', dueDate: 'Due today' },
  { id: 4, title: 'Update stage for CloudNine Systems', type: 'Stage Update', dueDate: 'Due tomorrow' },
  { id: 5, title: 'Add contact for FinFlow Systems deal', type: 'Missing Contact', dueDate: 'Due in 2 days' },
];

// Action detail data for Take Action modal
export const actionDetails = {
  1: {
    aiInsight: 'All stakeholders are aligned and legal has approved the terms. This is the perfect time to send the final contract. The deal is ready to close.',
    contact: { name: 'Sarah Thompson', title: 'VP of Operations', email: 'sarah.thompson@innovatelabs.com', avatar: 'ST', avatarColor: 'bg-indigo-900' },
    emailDraft: 'Hi Sarah,\n\nFollowing our successful alignment meetings and legal approval, I\'m pleased to share the final contract for your review.\n\nAll terms we discussed are included, and we\'re ready to move forward as soon as you\'re ready.\n\nLooking forward to partnering with Innovate Labs!',
  },
  2: {
    aiInsight: 'TechScale has gone quiet after the proposal. Their evaluation period typically lasts 10 days, we\'re now at day 15. A targeted follow-up referencing similar wins could re-engage them.',
    contact: { name: 'Michael Chen', title: 'Head of Engineering', email: 'michael.chen@techscale.com', avatar: 'MC', avatarColor: 'bg-teal-600' },
    emailDraft: 'Hi Michael,\n\nI wanted to follow up on the proposal we shared two weeks ago. I understand these decisions take time.\n\nI thought you might find it helpful to know that GrowthForce, a company with a similar tech stack, recently saw a 40% improvement in pipeline visibility after implementing our solution.\n\nWould you have 15 minutes this week to discuss any questions?',
  },
  3: {
    aiInsight: 'Your champion at DataDriven Co has been silent for 8 days. The VP of Sales may be a better contact to re-engage the conversation and keep the deal moving.',
    contact: { name: 'James Wilson', title: 'VP of Sales', email: 'james.wilson@datadriven.co', avatar: 'JW', avatarColor: 'bg-orange-600' },
    emailDraft: 'Hi James,\n\nI hope this finds you well. I\'ve been working with your team on the analytics platform evaluation and wanted to reach out directly.\n\nWe\'re excited about the potential fit and would love to keep the conversation moving. Would you be available for a quick sync this week?\n\nHappy to adjust to your schedule.',
  },
  4: {
    aiInsight: 'CloudNine Systems has a technical deep-dive scheduled for Thursday. Preparing integrations slides will help address their key concerns about API compatibility.',
    contact: { name: 'Emily Rodriguez', title: 'CTO', email: 'emily.rodriguez@cloudnine.com', avatar: 'ER', avatarColor: 'bg-purple-600' },
    emailDraft: 'Hi Emily,\n\nLooking forward to our deep-dive session on Thursday. I\'ve been preparing materials specifically around our integration capabilities.\n\nI\'ll cover REST API documentation, webhook support, and our new SDK that simplifies cloud service integrations.\n\nPlease let me know if there are any specific areas you\'d like me to focus on.',
  },
  5: {
    aiInsight: 'RetailHub Corp\'s renewal is approaching in 45 days. Scheduling a quarterly business review now ensures alignment on value delivered and expansion opportunities.',
    contact: { name: 'Lisa Martinez', title: 'Director of Revenue Ops', email: 'lisa.martinez@retailhub.com', avatar: 'LM', avatarColor: 'bg-pink-600' },
    emailDraft: 'Hi Lisa,\n\nWith your renewal coming up, I\'d love to schedule a quarterly business review to discuss the value we\'ve delivered and explore how we can support your growth plans.\n\nWould any time next week work for a 45-minute session?\n\nI\'ll prepare a summary of key metrics and recommendations.',
  },
};

// CRM Hygiene - Redesigned data
export const scheduledMeetings = [
  {
    id: 1,
    title: 'Discovery Meeting',
    company: 'FinTech Prime',
    contact: 'Amanda Richards',
    description: 'Discuss Q1 pipeline and expansion plans',
    time: '10:30 AM',
    duration: '30 min',
    type: 'call',
  },
  {
    id: 2,
    title: 'Platform Walkthrough',
    company: 'HealthTech Solutions',
    contact: 'Dr. Sarah Kim',
    description: 'Show HIPAA compliance features',
    time: '2:00 PM',
    duration: '45 min',
    type: 'meeting',
  },
];

export const tasksDueToday = [
  {
    id: 1,
    title: 'Send updated pricing proposal',
    company: 'CloudNine Systems',
    contact: 'Michael Torres',
    description: 'Include volume discount tiers',
    dueTime: 'Today 5:00 PM',
  },
  {
    id: 2,
    title: 'Update opportunity stage in Salesforce',
    company: 'DataDriven Co',
    contact: 'James Wilson',
    description: 'Move from Proposal to Negotiation',
    dueTime: 'Today 6:00 PM',
  },
];

// Account Detail data
export const accountDetails = {
  1: {
    stage: 'Commit',
    stageColor: 'bg-green-50 text-green-600 border-green-200',
    closeDate: 'Closes 30 Apr 2026',
    poc: { name: 'Sarah Chen', avatar: 'SC', avatarColor: 'bg-indigo-600' },
    dealSummary: 'CTO has been reviewing the proposal for the past 14 days with no recent engagement. Last contact was a pricing discussion on March 11th. Deal is currently stuck in the negotiation stage and requires immediate follow-up to maintain momentum and secure commitment before end of quarter.',
    pendingActions: {
      items: [
        { label: 'Send Contract', description: 'Final contract terms have been approved by legal. Need to send the signed enterprise agreement to the client for review and signature.' },
        { label: 'Schedule Executive Call', description: 'CTO requested a call to discuss implementation timeline and resource allocation before signing off on the contract.' },
        { label: 'Follow-up Email', description: 'Send a follow-up email referencing the March 11th pricing discussion and confirming the agreed-upon terms and next steps.' },
        { label: 'Update CRM Status', description: 'Update the deal stage in Salesforce to reflect current negotiation status. Add notes from last pricing discussion.' }
      ],
      assignedTo: { name: 'Sarah Chen', role: 'Account Executive', avatar: 'SC', avatarColor: 'bg-indigo-600' }
    },
    timeline: [
      { id: 1, type: 'inbound_email', title: 'Inbound Email: Q4 Budget Approval Status', time: '2 days ago', from: 'Sarah Chen', fromAvatar: 'SC', fromAvatarColor: 'bg-teal-700', description: 'Following up on our discussion regarding the Q4 budget allocation for the implementation phase.' },
      { id: 2, type: 'outbound_email', title: 'Outbound Email: Updated Implementation Plan', time: '4 days ago', from: 'Account Rep', fromAvatar: 'AR', fromAvatarColor: 'bg-green-600', description: 'Shared the revised implementation timeline with stakeholder feedback incorporated.' },
      { id: 3, type: 'stage_change', title: "Stage Changed to 'Negotiation'", time: '6 days ago', description: 'Deal progressed from Proposal to Negotiation stage after positive stakeholder feedback.' },
      { id: 4, type: 'meeting', title: 'Meeting: Technical Review Sync', time: '1 week ago', description: 'Reviewed technical requirements and integration roadmap with the engineering team.' },
      { id: 5, type: 'outbound_email', title: 'Outbound Email: Proposal Document', time: '2 weeks ago', from: 'Account Rep', fromAvatar: 'AR', fromAvatarColor: 'bg-green-600', description: 'Sent final proposal with pricing and implementation timeline.' },
    ],
    contacts: [
      { id: 1, name: 'Sarah Chen', title: 'Chief Technology Officer', avatar: 'SC', avatarColor: 'bg-teal-700', badge: 'Champion' },
      { id: 2, name: 'Marcus Wright', title: 'Director of IT Operations', avatar: 'MW', avatarColor: 'bg-blue-800' },
      { id: 3, name: 'Alex Rivera', title: 'Head of Procurement', avatar: 'AR', avatarColor: 'bg-orange-500' },
      { id: 4, name: 'Jessica Lowe', title: 'General Counsel', avatar: 'JL', avatarColor: 'bg-pink-500' },
    ],
  },
  2: {
    stage: 'Evaluation',
    stageColor: 'bg-yellow-50 text-yellow-600 border-yellow-200',
    closeDate: 'Closes 30 Apr 2026',
    poc: { name: 'Michael Chen', avatar: 'MC', avatarColor: 'bg-teal-600' },
    dealSummary: 'Prospect is evaluating competing solutions. Product demo was well-received but engineering team raised concerns about integration complexity. Need to address technical questions and schedule follow-up with VP of Technology.',
    pendingActions: {
      items: [
        { label: 'Send Technical Docs', description: 'Share comprehensive API documentation and integration architecture diagrams with the engineering team to address their concerns.' },
        { label: 'Schedule Follow-up Demo', description: 'Book a hands-on technical demo focused on integration workflows. Include solutions engineer to answer real-time questions.' },
        { label: 'Address Integration Concerns', description: 'Prepare a detailed response document addressing the three integration concerns raised during the product demo.' }
      ],
      assignedTo: { name: 'Michael Chen', role: 'Solutions Engineer', avatar: 'MC', avatarColor: 'bg-teal-600' }
    },
    timeline: [
      { id: 1, type: 'outbound_email', title: 'Outbound Email: Follow-up on Proposal', time: '5 days ago', from: 'Account Rep', fromAvatar: 'AR', fromAvatarColor: 'bg-green-600', description: 'Followed up on the pricing proposal sent last week.' },
      { id: 2, type: 'meeting', title: 'Meeting: Product Demo', time: '2 weeks ago', description: 'Conducted comprehensive product demonstration for the engineering team.' },
      { id: 3, type: 'stage_change', title: "Stage Changed to 'Evaluation'", time: '3 weeks ago', description: 'Prospect moved to evaluation after successful initial demo.' },
    ],
    contacts: [
      { id: 1, name: 'Michael Chen', title: 'Head of Engineering', avatar: 'MC', avatarColor: 'bg-teal-600', badge: 'Champion' },
      { id: 2, name: 'David Park', title: 'VP of Technology', avatar: 'DP', avatarColor: 'bg-indigo-700' },
      { id: 3, name: 'Rachel Kim', title: 'Product Manager', avatar: 'RK', avatarColor: 'bg-purple-600' },
    ],
  },
  3: {
    stage: 'Discovery',
    stageColor: 'bg-gray-100 text-gray-600 border-gray-200',
    closeDate: 'Closes 20 May 2026',
    poc: { name: 'Emily Rodriguez', avatar: 'ER', avatarColor: 'bg-purple-600' },
    dealSummary: 'Initial discovery call completed. Prospect has a strong need for compliance workflow automation. Key stakeholders identified but budget approval process is unclear.',
    pendingActions: {
      items: [
        { label: 'Send Case Study', description: 'Share the FinServ compliance automation case study that mirrors their workflow requirements and regulatory environment.' },
        { label: 'Schedule Discovery Follow-up', description: 'Book a deeper discovery session with the security team to map out compliance requirements and data handling policies.' },
        { label: 'Map Stakeholders', description: 'Create a stakeholder map identifying all decision-makers, their concerns, and the budget approval chain.' }
      ],
      assignedTo: { name: 'Emily Rodriguez', role: 'Account Executive', avatar: 'ER', avatarColor: 'bg-purple-600' }
    },
    timeline: [
      { id: 1, type: 'meeting', title: 'Meeting: Discovery Call', time: '3 days ago', description: 'Initial discovery call to understand requirements and pain points.' },
      { id: 2, type: 'inbound_email', title: 'Inbound Email: Feature Requirements', time: '1 week ago', from: 'Emily Rodriguez', fromAvatar: 'ER', fromAvatarColor: 'bg-purple-600', description: 'Shared a list of must-have features for their compliance workflow.' },
    ],
    contacts: [
      { id: 1, name: 'Emily Rodriguez', title: 'CTO', avatar: 'ER', avatarColor: 'bg-purple-600', badge: 'Champion' },
      { id: 2, name: 'Tom Hayes', title: 'Security Lead', avatar: 'TH', avatarColor: 'bg-gray-700' },
    ],
  },
  4: {
    stage: 'Proposal',
    stageColor: 'bg-yellow-50 text-yellow-600 border-yellow-200',
    closeDate: 'Closes 10 Apr 2026',
    poc: { name: 'James Wilson', avatar: 'JW', avatarColor: 'bg-orange-600' },
    dealSummary: 'Competitive pricing proposal sent with volume discounts. VP of Sales is the champion but CFO has concerns about implementation timeline. Need to address ROI concerns before next QBR.',
    pendingActions: {
      items: [
        { label: 'Send ROI Calculator', description: 'CFO requested a detailed ROI breakdown showing projected savings over 12 months and implementation risk assessment.' },
        { label: 'Schedule CFO Meeting', description: 'Set up a 30-minute call with the CFO to walk through the ROI model and address budget allocation concerns for Q2.' },
        { label: 'Update Pricing', description: 'Revise the pricing proposal to include flexible payment options and quarterly billing to ease the budget impact.' }
      ],
      assignedTo: { name: 'James Wilson', role: 'Senior AE', avatar: 'JW', avatarColor: 'bg-orange-600' }
    },
    timeline: [
      { id: 1, type: 'outbound_email', title: 'Outbound Email: Pricing Proposal', time: '1 day ago', from: 'Account Rep', fromAvatar: 'AR', fromAvatarColor: 'bg-green-600', description: 'Sent competitive pricing proposal with volume discounts.' },
      { id: 2, type: 'meeting', title: 'Meeting: Stakeholder Alignment', time: '5 days ago', description: 'Met with VP of Sales and RevOps to align on requirements.' },
      { id: 3, type: 'stage_change', title: "Stage Changed to 'Proposal'", time: '1 week ago', description: 'Advanced to proposal stage after completing evaluation.' },
    ],
    contacts: [
      { id: 1, name: 'James Wilson', title: 'VP of Sales', avatar: 'JW', avatarColor: 'bg-orange-600', badge: 'Champion' },
      { id: 2, name: 'Karen Li', title: 'RevOps Manager', avatar: 'KL', avatarColor: 'bg-rose-600' },
      { id: 3, name: 'Brian Foster', title: 'CFO', avatar: 'BF', avatarColor: 'bg-slate-600' },
    ],
  },
  5: {
    stage: 'Renewal',
    stageColor: 'bg-purple-50 text-purple-600 border-purple-200',
    closeDate: 'Closes 01 Jun 2026',
    poc: { name: 'Lisa Martinez', avatar: 'LM', avatarColor: 'bg-pink-600' },
    dealSummary: 'Renewal is approaching in 45 days. Customer has expressed interest in expanding to additional teams. QBR preparation underway to showcase delivered value and propose expansion.',
    pendingActions: {
      items: [
        { label: 'Prepare QBR Deck', description: 'Build the quarterly business review presentation showcasing usage metrics, ROI delivered, and expansion opportunities.' },
        { label: 'Send Expansion Proposal', description: 'Draft an expansion proposal for 3 additional teams based on the success metrics from the current deployment.' },
        { label: 'Schedule Renewal Call', description: 'Book the renewal discussion call with Director of Revenue Ops and VP of Sales to discuss terms and expansion.' }
      ],
      assignedTo: { name: 'Lisa Martinez', role: 'Customer Success Manager', avatar: 'LM', avatarColor: 'bg-pink-600' }
    },
    timeline: [
      { id: 1, type: 'inbound_email', title: 'Inbound Email: Renewal Discussion', time: '3 days ago', from: 'Lisa Martinez', fromAvatar: 'LM', fromAvatarColor: 'bg-pink-600', description: 'Expressed interest in expanding to additional teams during renewal.' },
      { id: 2, type: 'meeting', title: 'Meeting: QBR Prep', time: '1 week ago', description: 'Prepared quarterly business review materials with customer success team.' },
    ],
    contacts: [
      { id: 1, name: 'Lisa Martinez', title: 'Director of Revenue Ops', avatar: 'LM', avatarColor: 'bg-pink-600', badge: 'Champion' },
      { id: 2, name: 'Robert Chen', title: 'VP of Sales', avatar: 'RC', avatarColor: 'bg-blue-700' },
    ],
  },
  6: {
    stage: 'Contract',
    stageColor: 'bg-green-50 text-green-600 border-green-200',
    closeDate: 'Closes 05 Apr 2026',
    poc: { name: 'Sarah Chen', avatar: 'SC', avatarColor: 'bg-teal-700' },
    dealSummary: 'All terms agreed upon. Contract has been sent for final signature. Legal teams on both sides have completed review. Waiting for CFO sign-off on the final payment schedule.',
    pendingActions: {
      items: [
        { label: 'Follow-up on Signature', description: 'Check in with legal on the status of the contract signature. CFO availability is the blocker, confirm timing.' },
        { label: 'Confirm Payment Terms', description: 'Verify the final payment schedule has been approved by both finance teams before the signing ceremony.' },
        { label: 'Schedule Kickoff', description: 'Pre-schedule the implementation kickoff meeting for the week after contract signing to maintain momentum.' }
      ],
      assignedTo: { name: 'Sarah Chen', role: 'Account Executive', avatar: 'SC', avatarColor: 'bg-teal-700' }
    },
    timeline: [
      { id: 1, type: 'stage_change', title: "Stage Changed to 'Contract'", time: '2 days ago', description: 'All terms agreed. Contract sent for final signature.' },
      { id: 2, type: 'meeting', title: 'Meeting: Legal Review', time: '5 days ago', description: 'Final legal review of contract terms with both legal teams.' },
      { id: 3, type: 'outbound_email', title: 'Outbound Email: Final Terms', time: '1 week ago', from: 'Account Rep', fromAvatar: 'AR', fromAvatarColor: 'bg-green-600', description: 'Shared the finalized contract with updated payment schedule.' },
    ],
    contacts: [
      { id: 1, name: 'Sarah Chen', title: 'VP of Engineering', avatar: 'SC', avatarColor: 'bg-teal-700', badge: 'Champion' },
      { id: 2, name: 'Daniel Kim', title: 'Legal Counsel', avatar: 'DK', avatarColor: 'bg-gray-600' },
      { id: 3, name: 'Amy Zhang', title: 'Procurement Lead', avatar: 'AZ', avatarColor: 'bg-amber-600' },
    ],
  },
  7: {
    stage: 'Proposal',
    stageColor: 'bg-yellow-50 text-yellow-600 border-yellow-200',
    closeDate: 'Closes 25 Apr 2026',
    poc: { name: 'David Kim', avatar: 'DK', avatarColor: 'bg-indigo-600' },
    dealSummary: 'Budget concerns raised by VP after executive briefing. Need to revise pricing to fit Q2 allocation. ROI analysis was well-received but CFO needs more data points.',
    pendingActions: {
      items: [
        { label: 'Revise Pricing', description: 'Create a revised pricing model with flexible payment options that fit within their Q2 budget constraints.' },
        { label: 'Send Updated Proposal', description: 'Package the revised pricing with the ROI analysis into an updated proposal document for executive review.' },
        { label: 'Schedule Budget Call', description: 'Set up a call with VP and finance team to walk through the revised pricing and address remaining concerns.' }
      ],
      assignedTo: { name: 'David Kim', role: 'Account Executive', avatar: 'DK', avatarColor: 'bg-indigo-600' }
    },
    timeline: [
      { id: 1, type: 'inbound_email', title: 'Inbound Email: Budget Concerns', time: '1 day ago', from: 'David Kim', fromAvatar: 'DK', fromAvatarColor: 'bg-indigo-600', description: 'Raised concerns about budget allocation for Q2. Needs revised pricing.' },
      { id: 2, type: 'meeting', title: 'Meeting: Executive Briefing', time: '4 days ago', description: 'Presented ROI analysis to the executive team.' },
    ],
    contacts: [
      { id: 1, name: 'David Kim', title: 'VP of AI/ML', avatar: 'DK', avatarColor: 'bg-indigo-600', badge: 'Champion' },
      { id: 2, name: 'Sophie Wang', title: 'Head of Data Science', avatar: 'SW', avatarColor: 'bg-violet-600' },
    ],
  },
  8: {
    stage: 'Discovery',
    stageColor: 'bg-gray-100 text-gray-600 border-gray-200',
    closeDate: 'Closes 15 May 2026',
    poc: { name: 'Rachel Park', avatar: 'RP', avatarColor: 'bg-cyan-600' },
    dealSummary: 'New prospect in financial analytics space. Initial intro call completed. Strong interest in automated reporting capabilities. Need to understand their current tech stack better.',
    pendingActions: {
      items: [
        { label: 'Send Product Overview', description: 'Share the comprehensive product overview deck highlighting financial analytics and automated reporting capabilities.' },
        { label: 'Schedule Tech Assessment', description: 'Book a technical assessment session to understand their current data infrastructure and integration requirements.' },
        { label: 'Share Case Study', description: 'Send the FinTech analytics case study showing how similar companies achieved 40% faster reporting cycles.' }
      ],
      assignedTo: { name: 'Rachel Park', role: 'SDR', avatar: 'RP', avatarColor: 'bg-cyan-600' }
    },
    timeline: [
      { id: 1, type: 'meeting', title: 'Meeting: Intro Call', time: '2 days ago', description: 'Initial introduction call to discuss financial analytics needs.' },
    ],
    contacts: [
      { id: 1, name: 'Rachel Park', title: 'Head of Analytics', avatar: 'RP', avatarColor: 'bg-cyan-600', badge: 'Champion' },
      { id: 2, name: 'Andrew Lee', title: 'CFO', avatar: 'AL', avatarColor: 'bg-emerald-700' },
    ],
  },
};

// Settings - Connectors
export const connectors = [
  { id: 1, name: 'Salesforce', description: 'Sync deals, contacts, and activities from your CRM.', status: 'Connected', icon: 'cloud' },
  { id: 2, name: 'HubSpot', description: 'Pull pipeline data and engagement metrics.', status: 'Not Connected', icon: 'triangle' },
  { id: 3, name: 'Gmail', description: 'Track email engagement and response times.', status: 'Connected', icon: 'mail' },
  { id: 4, name: 'Outlook', description: 'Monitor email activity and meeting schedules.', status: 'Not Connected', icon: 'mailbox' },
  { id: 5, name: 'Slack', description: 'Get real-time alerts and notifications.', status: 'Placeholder', icon: 'message' },
  { id: 6, name: 'Calendly', description: 'Track meeting bookings and attendance.', status: 'Not Connected', icon: 'calendar' },
];

// Settings - CRM Stages
export const crmStages = [
  { name: 'Discovery', description: 'Initial contact and qualification phase', mapping: 'Discovery' },
  { name: 'Evaluation', description: 'Product demo and evaluation stage', mapping: 'Qualification' },
  { name: 'Proposal', description: 'Proposal sent to prospect', mapping: 'Proposal' },
  { name: 'Negotiation', description: 'Terms and pricing negotiation', mapping: 'Negotiation' },
  { name: 'Contract', description: 'Contract signed and closed', mapping: 'Closed Won' },
];

// Settings - Signals
export const signalConfig = {
  inactivityThreshold: 14,
  stageSLA: {
    Discovery: 7,
    Evaluation: 21,
    Proposal: 14,
    Negotiation: 10,
    Contract: 14,
  },
};

export const users = [
  {
    id: 1,
    name: 'Sarah Thompson',
    email: 'sarah.thompson@company.com',
    avatar: 'ST',
    avatarColor: 'bg-blue-600',
    role: 'Admin',
    roleColor: 'bg-gray-100 text-gray-700',
    status: 'Connected',
    statusColor: 'text-green-600',
    lastActive: '2 hours ago'
  },
  {
    id: 2,
    name: 'Michael Chen',
    email: 'michael.chen@company.com',
    avatar: 'MC',
    avatarColor: 'bg-teal-600',
    role: 'AE',
    roleColor: 'bg-blue-100 text-blue-700',
    status: 'Connected',
    statusColor: 'text-green-600',
    lastActive: '5 hours ago'
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    email: 'emily.rodriguez@company.com',
    avatar: 'ER',
    avatarColor: 'bg-purple-600',
    role: 'CSM',
    roleColor: 'bg-green-100 text-green-700',
    status: 'Connected',
    statusColor: 'text-green-600',
    lastActive: '1 day ago'
  },
  {
    id: 4,
    name: 'James Wilson',
    email: 'james.wilson@company.com',
    avatar: 'JW',
    avatarColor: 'bg-orange-600',
    role: 'AE',
    roleColor: 'bg-blue-100 text-blue-700',
    status: 'Pending',
    statusColor: 'text-gray-600',
    lastActive: 'Never'
  }
];
